import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { Edit, PlusCircle } from "feather-icons-react/build/IconComponents";
import Error404 from "MainPages/ErrorPages/error404";
import PublicHolidayForm from "./PublicHolidayForm";
import { useForm, FormProvider } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import ToastNotification from "Components/UI/ToastNotification";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import {
  useCreatePublicHolidayMutation,
  useGetPublicHolidaysQuery,
  useUpdatePublicHolidayMutation,
} from "AppQuries/leave/public-holiday/public-holiday";
import { useUpdateDepartmentMutation } from "AppQuries/master/Department/update-department";
import { publicHolidayValidationSchema } from "core/Operations/ValidationSchema/leaveValidaitionSchema";
import ReportTools from "Components/UI/ReportTools";
import { Upload } from "react-feather";
import useTableExport from "core/Operations/useTableExport";
import { toast } from "core/Operations/toast";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";

const PublicHoliday = () => {
  const userData = useSelector(loggedInUser);

  const methods = useForm({
    resolver: yupResolver(publicHolidayValidationSchema),
  });
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: GetPublicHolidays,
  } = useGetPublicHolidaysQuery({
    companyCode: userData.companyCode,
  });

  const { mutate: addPublicHoliday } = useCreatePublicHolidayMutation();
  const { mutate: updatePublicHoliday } = useUpdatePublicHolidayMutation();

  const [selectedPublicHoliday, setSelectedPublicHoliday] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const publicHolidayData = data?.map((d, _id) => ({
    ...d,
    id: _id + 1,
    holidayDate: format(new Date(d.holidayDate), "yyyy-MM-dd"),
  }));

  const handleAddClick = () => {
    setSelectedPublicHoliday(null);
    methods.reset({
      companyCode: userData.companyCode,
      code: 0,
      description: "",
      holidayDate: "",
      isActive: true,
      createUser: userData.userName,
      modifyUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (leave) => {
    setSelectedPublicHoliday(leave);
    methods.reset({
      companyCode: leave.companyCode,
      code: leave.code,
      description: leave.description,
      holidayDate: format(new Date(leave.holidayDate), "yyyy-MM-dd"),
      isActive: leave.isActive,
      createUser: leave.createUser,
      modifyUser: userData.userName,
      createDate: leave.createDate,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const onSubmit = async (payload) => {
    console.log(payload);
    if (selectedPublicHoliday) {
      updatePublicHoliday(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Public Holiday Updated Successfully.");

            setSelectedPublicHoliday(null);
            setShow(false);
            GetPublicHolidays();
          } else {
            toast.warning("Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    } else {
      addPublicHoliday(payload, {
        onSuccess: (data) => {
          if (data?.data) {
            toast.success("Public Holiday Added Successfully.");

            setShow(false);
            GetPublicHolidays();
          } else {
            toast.warning(error.message || "Something went wrong.");
          }
        },
        onError: (error) => {
          toast.error(error.message || "Something went wrong.");
        },
      });
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: "Holiday Date",
      dataIndex: "holidayDate",
      sorter: (a, b) => a.holidayDate.length - b.holidayDate.length,
      // render: (text, record) => (
      //   <>{format(new Date(record.holidayDate), "dd-MM-yyyy")}</>
      // ),
    },

    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.Description.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },

    {
      title: "Action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.leave_adjustment}
            accessCode={accessCodes.leave_holiday_calender}
            accessType="haveEdit"
          >
            <Link
              className="me-2 p-2"
              to="#"
              onClick={() => handleEditClick(record)}
            >
              <Edit className="feather-edit" />
            </Link>
          </Can>
          {/* <Can accessModule={accessCodes.leave_adjustment} accessCode={accessCodes.leave_holiday_calender} accessType="haveDelete">
          <Popconfirm
              title="Are you sure to Delete?"
              onConfirm={() => removeHolidayHandler(record.Code)}
            >
              <img src={DeleteIcon} alt="img" />
            </Popconfirm>
            </Can> */}
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    publicHolidayData,
    searchColumns
  );

  const { onExcelPrint } = useTableExport({
    columns: columns,
    data: filteredData,
    fileName: "Holidays",
  });

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Public Holidays</h4>
                <h6>Manage your Public Holidays</h6>
              </div>
            </div>

            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Public Holidays Master"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={GetPublicHolidays}
              />
            </div>

            <div className="page-btn">
              <Can accessModule={accessCodes.leave_adjustment} accessCode={accessCodes.leave_holiday_calender} accessType="haveAdd">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Add New PublicHoliday</Tooltip>
                }
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  <PlusCircle className="me-2" />
                  Add New PublicHoliday
                </Link>
              </OverlayTrigger>
              </Can>
            </div>

            <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onExcelPrint}
              >
                <Upload className="me-2" />
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop onSearch={setSearchValue} />
                  <div className="table-responsive">
                    <Table
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <PublicHolidayForm
          mode={selectedPublicHoliday ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </div>
  );
};

export default PublicHoliday;
